<template>
    <div class="header">
        <v-container fluid class="header-container py-0">
            <v-row class="text-center" align="center">
                <v-col col lg="8" class="py-0">
                    <v-row align="center">
                        <div class="logo-wrapper">
                        <a href="/" class="logo"></a>
                        <span class="logo-title">Umbrella</span>
                        </div>
                    </v-row>
                </v-col>
                <v-col col lg="4" class="text-right">
                    <template>
                            <v-menu
                                    :close-on-content-click="false"
                                    :nudge-width="200"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                            color="white"
                                            dark
                                            text
                                            large
                                            v-bind="attrs"
                                            v-on="on"
                                            class="text-capitalize px-0"
                                    >
                                        <span class="username">{{getUserName()}}</span>
                                        <v-icon small>mdi-menu-down</v-icon>
                                        <img class="user-avatar" :src="getUrlAvatar()" />
                                    </v-btn>
                                </template>

                                <v-card class="text-right">
                                    <div class="pa-4">
                                        You are currently signed in as<br>
                                        <strong>{{getUserEmail()}}</strong>
                                    </div>
                                    <v-divider></v-divider>

                                    <v-list>
                                        <v-list-item to="/logout">
                                            <v-list-item-title>Sign out <v-icon class="pl-2" small>fas fa-sign-out-alt</v-icon></v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-card>
                            </v-menu>
                    </template>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Header',
  data() {
    return {
    };
  },
  computed: {
    ...mapState('user', ['user']),
  },
  methods: {
    getUrlAvatar() {
      return this.user.length > 0 && this.user[0].picture;
    },
    getUserEmail() {
      return this.user.length > 0 && this.user[0].email;
    },
    getUserName() {
      return this.user.length > 0 && this.user[0].name;
    },
  },
};
</script>

<style lang="sass">
    span.logo-title
        font-size: 14px
        font-weight: 700
        text-transform: uppercase
        letter-spacing: 6.9px
        opacity: 1

    .header
        // background: #3A3852
        .logo-wrapper
            position: relative

        .logo
            transition: all 0.5s ease

            &:hover
                cursor: pointer

        .user-avatar
            float: right
            border-radius: 100%
            width: 2.5em
            height: 2.5em
            margin-left: 10px

        .nav
            display: block
            margin-top: 3px
            text-align: right

        .nav-item
            .dropdown-toggle
                white-space: nowrap
                padding: 0
                transition: all 0.5s ease

                span
                    color: #fff
                    font-size: 12px
                    font-weight: 700
                    letter-spacing: 0.5px
                    text-decoration: none
                    line-height: 1rem
                    text-align: right

                    &:hover
                        color: #67E6F5
                        cursor: pointer

                &::after
                    display: inline-block
                    margin-left: 0.255em
                    vertical-align: middle
                    content: ""
                    border-top: 0.2em solid
                    border-right: 0.2em solid transparent
                    border-bottom: 0
                    border-left: 0.2em solid transparent
                    color: rgba(255, 255, 255, 0.5)

        span.user
            float: right

        .dropdown-menu
            text-align: right

        .dropdown-menu.dropdown-menu-right.show
            top: 5px !important

        .dropdown-item
            display: block
            width: 100%
            padding: 0.1rem 1rem
            clear: both
            font-size: 14px
            font-weight: 400
            color: #5c6489
            text-align: inherit
            white-space: nowrap
            background-color: transparent
            border: 0

            strong
                color: #3a3852
                font-size: 14px
                font-weight: 700

            &:hover, &:focus
                background-color: transparent

            a
                text-decoration: none

                span
                    color: #3a3852
                    font-size: 12px
                    font-weight: 700
                    letter-spacing: 1px
                    text-decoration: none
                    text-transform: uppercase

                    &:hover
                        color: #36b8e1
                        cursor: pointer

</style>
